import { Facebook, Instagram, WhatsApp } from '@material-ui/icons';
import classNames from 'classnames';
import React from 'react';

const FooterNav = ({
  className,
  ...props
}) => {

  const classes = classNames(
    'footer-nav',
    className
  );

  return (
    <nav
      {...props}
      className={classes}
    >
      <ul className="list-reset">
        <li>
          <a target="_blank" to="https://wa.me/556699984060?text=Olá, estou entrando em contato pelo site SVPrivacidade, gostaria de informações sobre a política de privacidade do aplicativo."><WhatsApp fontSize={"small"} /></a>
        </li>
        <li>
          <a target="_blank" to="https://www.facebook.com/Ruralhub.snp"><Facebook fontSize={"small"} /></a>
        </li>

        <li>
          <a target="_blank" to="https://www.instagram.com/ruralhub.oficial"><Instagram fontSize={"small"} /></a>
        </li>
      </ul>
    </nav>
  );
}

export default FooterNav;